<template>
  <div class="el-main-1" style="background-color:ghostwhite;margin-top: 20px;">
    <el-row type="flex">
      <el-col :span="5">
        <div style="background-color:#fff">
          <div style="margin-left: 10px;   text-align: left;  color: #0162c3 ; font-weight: bold; height: 60px; display: flex ;align-items: center; ">
            <i class="el-icon-position"> </i> 办事指南
          </div>
          <el-menu default-active="1" style="background-color:rgb(124, 203, 199)">
            <el-menu-item index="1" style="margin: 0px; font-size: 20px; ">全部</el-menu-item>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="19" style="margin-left:50px">
        <div style="background-color:#fff; " >
          <el-breadcrumb separator="/"  style="height:60px;margin-left: 10px;  font-size:20px; display: flex ;align-items: center;">
            <el-breadcrumb-item ><a class=""  v-on:click ="routeFunc" >首页</a></el-breadcrumb-item>
            <el-breadcrumb-item >办事指南</el-breadcrumb-item>
            <el-breadcrumb-item >全部</el-breadcrumb-item>
          </el-breadcrumb>
          <el-divider></el-divider>
          <div>
            <div class="tzgg-ul">
              <div v-for="guid in guidList" :key="guid.id" class="text tzgg-ul-li">
                <i class=""></i> 
                <a class="" @click="routeFuncDetail(guid.id)">{{ guid.theme }}</a>
                <span class="">{{ guid.createTime }}</span>
              </div>  
            </div>
          </div>
          <el-pagination
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="pager.pageSize"
            :total="pager.totalCount" style="margin-top : 20px; margin-bottom: 20px;">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>                        
<script>
// 引入组件
import axios from  '@/api/axiosConfig'
import SERVICE_URL  from  '@/api/url'
import {MESSAGE_DURATION} from  '@/api/constant'
export default {
  name : 'pc_notice',
  data() {
    return {
      guidList:[],
      pager:{
        totalCount:0,
        pageSize : 10                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
      },
    }
  },
  methods : {
    routeFunc(){
      window.parent.postMessage({
        data: "1",
      }, '*');
    },

    routeFuncDetail( id){
      let left0 =  (window.screen.availWidth-10-1000)/2
      let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=1000,height=1000,left=${left0},top=100`;
      window.open(SERVICE_URL + "/#/pc_editor_view/" +id +"?fileType=办事指南" ,"test",params0);
    },
    handleCurrentChange(val){
      this.guidListLoad(val);
    },
    guidListLoad(pageNo){
      let url = "/bc/exa/guid/guidPage"
      let dat0 = {
        pageSize: 10,
        pageNo,
        active:1
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            this.guidList =[]
            dat.data.forEach(t=>this.guidList.push(t))
            this.pager.totalCount = dat.totalDataCount
          } else {
            this.$message({
              showClose: true,
              message: '未查询到办事指南信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
  },
  created(){
    setTimeout(()=>{ this.guidListLoad(1) },200)
  },
  components: {
  }
}
</script>
  
<style lang="less" scoped>

.el-main-1 {
  width: 100%;
  margin-top:0px;
  padding: auto;
  // background-color:rgb(130, 20, 20);
  // background-color:#f9fafc;
  color: #333;
  text-align: center;
  height: calc(100% - 20px);
  overflow:auto;
}

.el-row {
  padding: auto;
  margin: auto;
  height: 300px;
  width: 1400px;
  font-size: large;
  text-align: center;
}

.el-divider--horizontal{
  background-color: #2577d5;
  height: 2px;
  margin: 1px 0 10px 0;
  width: 100%
}


.tzgg-ul{
    width:90%;
    margin: auto;
    &:first-child {
      margin-top: 20px;
    }
    .tzgg-ul-li{
      height: 50px;
      line-height: 18px;
      font-size: 18px;
      border-bottom: 1px solid #DCDFE6;
      display: flex ;
      align-items: center;
      i{
        width:5px;
        height:5px;
        display:inline-block;
        background-color:rgb(124, 203, 199);
        margin-bottom: 5px;
        margin-left: 5px;
        transform:rotate(45deg);
      }
      a{
        width:75%;
        overflow: hidden;
        padding-left: 1em;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        text-align: left;
        font-size: 1em;
      }
      span{
        width:20%;
        display:inline-block;
        font-size: 0.8em;
        color: #6F6F6F;
        white-space: nowrap;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_component/pc_guid.vue